import {
  FRONTSTAFF_TESTORDER_LIST_LOADING,
  FRONTSTAFF_TESTORDER_RESET,
  FRONTSTAFF_TESTORDER_LOAD_PAGE,
  FRONTSTAFF_TESTORDER_ERROR,
  FRONTSTAFF_TESTORDER_LOADING_ON_SUBMIT,
  FRONTSTAFF_TESTORDER_GET_BY_ID,
  FRONTSTAFF_TESTORDER_UPDATED,
  FRONTSTAFF_TESTORDER_LIST_UPDATED,
  FRONTSTAFF_TESTORDER_SEARCH_PARAMATERS_UPDATE,
} from "actions/types";
import * as Constants from "constants/index";
//
const initialState = {
  testOrderList: {
    page: 1,
    data: [],
    count: 0
  },
  currentTestOrder: null,
  loadingTestOrderList: true,
  loadingTestOrder: true,
  // loadingUploadTestOrder: false,
  loadingListData: true,
  error: {},
  sortingParams: {
    limit: 50,
    page: 1,
    orderBy: "scheduleDate",
    ascending: "desc",
    query: "",
    filters: [],
  },
  performDelete: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FRONTSTAFF_TESTORDER_RESET:
      return {
        ...initialState,
        loadingTestOrder: state.loadingTestOrder,
        loadingTestOrderList: state.loadingTestOrderList,
        loadingListData: state.loadingListData,
      }
    case FRONTSTAFF_TESTORDER_LOAD_PAGE:
      return {
        ...state,
        loadingTestOrder: false,
        loadingListData: false,
        // loadingUploadTestOrder: false
      };
    case FRONTSTAFF_TESTORDER_UPDATED:
      return {
        ...state,
        currentTestOrder: null,
        sortingParams: initialState.sortingParams,
        loadingTestOrder: false,
      };
    case FRONTSTAFF_TESTORDER_ERROR:
      return {
        ...state,
        error: payload,
        loadingTestOrder: false,
        loadingTestOrderList: false,
        loadingListData: false,
        performDelete: false,
      };
    case FRONTSTAFF_TESTORDER_GET_BY_ID:
      return {
        ...state,
        currentTestOrder: payload,
        loadingTestOrder: false,
      };
    case FRONTSTAFF_TESTORDER_LIST_UPDATED:
      return {
        ...state,
        testOrderList: {
          data: payload.data,
          page: payload.metadata.length ? payload.metadata[0].current_page : 1,
          count: payload.metadata.length ? payload.metadata[0].totalRecord : 0,
        },
        loadingTestOrderList: false,
        loadingListData: false,
        performDelete: false,
      };
    case FRONTSTAFF_TESTORDER_SEARCH_PARAMATERS_UPDATE:
      return {
        ...state,
        sortingParams: { ...payload }
      };
    case FRONTSTAFF_TESTORDER_LIST_LOADING:
      return {
        ...state,
        loadingListData: true
      };
    case FRONTSTAFF_TESTORDER_LOADING_ON_SUBMIT:
      return {
        ...state,
        loadingTestOrder: true,
        // loadingUploadTestOrder: true
      };
    default:
      return state;
  }
}
